import React from "react";
import { graphql } from "gatsby";
import Layout from "../../layouts";
import SEO from "@herb/components/seo";
import { deployUrl } from "@herb/utils";
import DealCategoryContents from "@herb/components/DealCategoryContents";
import "./index.css";

const Deals = ({ data }) => {
  const { dealsCategories, wordpressWpPage, deals } = data;

  return (
    <>
      <div className="dealsPageMain">
        <Layout page="deals">
          <SEO
            title="Best Weed Deals: Explore The Top Cannabis Discounts"
            description="Herb Deals"
            url="/deals"
            canonical={`${deployUrl}/deals`}
            breadcrumbs={[]}
          />
          <DealCategoryContents
            categories={dealsCategories?.nodes || []}
            activeCategory={wordpressWpPage}
            deals={deals?.nodes || []}
            sortedDeals={dealsCategories?.dealCategoryContent?.sortedDeals || []}
            allDealsCategoryImage={
              wordpressWpPage?.dealCategoryContent?.categoryImage
            }
          />
        </Layout>
      </div>
    </>
  );
};

export default Deals;

export const pageQuery = graphql`
  query {
    wordpressWpPage(slug: { eq: "deals" }) {
      id
      dealCategoryContent {
        banner {
          mainBannerImage {
            sourceUrl
            altText
          }
          mobileBannerImage {
            sourceUrl
            altText
          }

          link
        }
        categoryImage {
          sourceUrl
          altText
        }
        noDeals
        sortedDeals {
          ... on WordpressWpDeal {
            id
            title
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
            contentMobileImage {
              mobileImage {
                altText
                sourceUrl
              }
            }
            contentDeals {
              contentDeals {
                product {
                  ... on WordpressWpProduct {
                    id
                    contentProducts {
                      productImages {
                        title
                        sourceUrl
                      }
                    }
                    title
                    brand_name
                  }
                }
                customTitle
                badgeText
                badgeColor
                badgeBackgroundColor
                dealLink
                ctaLabel
                ctaColor
                ctaBackgroundColor
                dealOffer
                dealOfferColor
              }
            }
          }
        }
        categorySubtext
        categorySubtext2
        faqs {
          heading
          description
          qas {
            question
            answer
          }
        }
        details {
          heading
          description1
          description2
        }
      }
    }

    dealsCategories: allWordpressWpDealCategory {
      nodes {
        id
        slug
        name
        databaseId
        dealCategoryContent {
          banner {
            mainBannerImage {
              sourceUrl
              altText
            }
            mobileBannerImage {
              sourceUrl
              altText
            }
            link
          }
          categoryImage {
            sourceUrl
            altText
          }
        }
      }
    }
    deals: allWordpressWpDeal {
      nodes {
        id
        title
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        contentMobileImage {
          mobileImage {
            altText
            sourceUrl
          }
        }
        contentDeals {
          contentDeals {
            product {
              ... on WordpressWpProduct {
                id
                contentProducts {
                  productImages {
                    title
                    sourceUrl
                  }
                }
                title
                brand_name
              }
            }
            customTitle
            badgeText
            badgeColor
            badgeBackgroundColor
            dealLink
            ctaLabel
            ctaColor
            ctaBackgroundColor
            dealOffer
            dealOfferColor
          }
        }
      }
    }
  }
`;
